import React from 'react'

const ProfileInfo = () => {
    return (
        <div className="content about">

            <div className="title">About Me</div>

            <div className="row">
                <div className="col col-d-6 col-t-6 col-m-12 border-line-v">
                    <div className="text-box">
                        <p>
                            I am Piyush Talele, Technical Lead offering 8 years leading cross-functional teams and completing projects on-time.<br />
        Exceptional success in delivering complex software development projects on time and within budget to exceed expectations.<br />
        Strongly initiative, creative and able to learn new technologies and systems.<br />
        Active participation in Scrum Practices from Scrum Planning, Scrum Review to Scrum Retrospective meetings
        </p>
                    </div>
                </div>
                <div className="col col-d-6 col-t-6 col-m-12 border-line-v">
                    <div className="info-list">
                        <ul>
                            <li><strong>Age . . . . .</strong> 30</li>
                            <li><strong>Residence . . . . .</strong> India</li>
                            <li><strong>Address . . . . .</strong> Pune, Maharahstra, India</li>
                        </ul>
                    </div>
                </div>
                <div className="clear"></div>
            </div>

        </div>
    );
}

export default ProfileInfo;